import { render, staticRenderFns } from "./RoleAdmin.vue?vue&type=template&id=3164689d&scoped=true&"
import script from "./RoleAdmin.vue?vue&type=script&lang=js&"
export * from "./RoleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RoleAdmin.vue?vue&type=style&index=0&id=3164689d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164689d",
  null
  
)

export default component.exports